import { GlSkeletonLoader, GlTooltipDirective, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { GlSingleStat } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/charts.js?vue3';
import Api from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/api.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { sprintf, __, s__ } from '~/locale';
import Tracking, { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
const MERGE_REQUESTS_TRACKING_LABEL = 'g_analytics_activity_widget_mr_created_clicked';
const ISSUES_TRACKING_LABEL = 'g_analytics_activity_widget_issues_created_clicked';
const NEW_MEMBERS_TRACKING_LABEL = 'g_analytics_activity_widget_members_added_clicked';
const ACTIVITY_COUNT_LIMIT = 999;
export default {
    name: 'GroupActivityCard',
    components: {
        GlSkeletonLoader,
        GlSingleStat,
        GlLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        Tracking.mixin(),
        InternalEvents.mixin()
    ],
    inject: [
        'canReadBilling',
        'showPlanIndicator',
        'groupBillingsPath',
        'groupSubscriptionPlanName',
        'groupFullPath',
        'mergeRequestsMetricLink',
        'issuesMetricLink',
        'newMembersMetricLink'
    ],
    data () {
        return {
            isLoading: false,
            metrics: {
                mergeRequests: {
                    value: null,
                    label: s__('GroupActivityMetrics|Merge requests created'),
                    link: this.mergeRequestsMetricLink,
                    trackingLabel: MERGE_REQUESTS_TRACKING_LABEL
                },
                issues: {
                    value: null,
                    label: s__('GroupActivityMetrics|Issues created'),
                    link: this.issuesMetricLink,
                    trackingLabel: ISSUES_TRACKING_LABEL
                },
                newMembers: {
                    value: null,
                    label: s__('GroupActivityMetrics|Members added'),
                    link: this.newMembersMetricLink,
                    trackingLabel: NEW_MEMBERS_TRACKING_LABEL
                }
            }
        };
    },
    computed: {
        metricsArray () {
            return Object.entries(this.metrics).map(([key, obj])=>{
                const { value, label, link, trackingLabel } = obj;
                return {
                    key,
                    value,
                    label,
                    link,
                    trackingLabel
                };
            });
        }
    },
    created () {
        this.fetchMetrics(this.groupFullPath);
    },
    methods: {
        fetchMetrics (groupPath) {
            this.isLoading = true;
            return Promise.all([
                Api.groupActivityMergeRequestsCount(groupPath),
                Api.groupActivityIssuesCount(groupPath),
                Api.groupActivityNewMembersCount(groupPath)
            ]).then(([mrResponse, issuesResponse, newMembersResponse])=>{
                this.metrics.mergeRequests.value = mrResponse.data.merge_requests_count;
                this.metrics.issues.value = issuesResponse.data.issues_count;
                this.metrics.newMembers.value = newMembersResponse.data.new_members_count;
                this.isLoading = false;
            }).catch(()=>{
                createAlert({
                    message: __('Failed to load group activity metrics. Please try again.')
                });
                this.isLoading = false;
            });
        },
        clampValue (value) {
            return value > ACTIVITY_COUNT_LIMIT ? '999+' : `${value}`;
        },
        tooltip (value) {
            return value > ACTIVITY_COUNT_LIMIT ? __('Results limit reached') : null;
        },
        clickMetric (trackingLabel) {
            this.track('click_button', {
                label: trackingLabel
            });
        },
        handlePlanIndicatorClick () {
            this.trackEvent('click_plan_indicator_on_group_overview_page');
        }
    },
    activityTimeSpan: sprintf(__('Last %{days} days'), {
        days: 30
    })
};
